<template>
    <transition name="modal">
        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h4 class="modal-title"><strong>Agregar curso a rutas</strong></h4>
                            <button type="button" class="close" data-dismiss="modal">×</button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <table class="table table-sm text-center align-middle mt-3 small">
                                <thead class="">
                                    <tr>
                                        <th scope="col">
                                            <!--<span class="text-primary fw-bold">
                                                <input v-model="isCheckedSelectAll" class="form-check-input" @change="selectAll" type="checkbox" />
                                                ({{ selectedRoutes.length}}/{{ dessertsRoutes ? dessertsRoutes.length : 0 }})
                                            </span>-->
                                        </th>
                                        <th scope="col">Nombre de la ruta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) of dessertsRoutes" :key="index">
                                        <td>
                                            <div class="form-check">
                                                <input v-model="selectedRoutes" class="form-check-input inputUser"  type="checkbox" :value="item.id" :id="'checkStudent' + item.id" />
                                            </div>
                                        </td>
                                        <td>{{ item.name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn text-primary sin-borde bg-utel-v2-secondary mx-3 rounded-8" id="cancel-button-routes" @click="close"
                                aria-label="Close modal" data-dismiss="modal">
                                Cancelar
                            </button>
                            <button type="button" id="update-button-routes" class="btn text-white bg-utel rounded-8" :disabled="btnEnviarDisabled" @click="agregarCursosARuta" aria-label="Agregar usuario a ruta" data-dismiss="modal" v-html="btnTextGuardarCambios"></button>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>        
    </transition>
</template>

<script>
export default {
    props: ['course', 'url_routes_by_company'],
    data() {
        return {
            dessertsRoutes: [],
            selectedRoutes : [],
            isCheckedSelectAll: false,
            btnEnviarDisabled: false ,
            btnTextGuardarCambios: 'Guardar cambios'
        }
    },
    mounted() {
        this.getRoutes();
    },
    methods: {
        close() {
            this.$emit('close');
        },
        reloadTable(){
            this.$emit('reloadtable', true);
        },
        getRoutes(){
            let context = this;
            let url = this.url_routes_by_company;

            axios
            .get(`${url}?course_wp_id=${context.course.id}`)
            .then((res) => { 
                console.log(res.data.data);
                context.dessertsRoutes = res.data.data; 
            });
        },
        agregarCursosARuta() {
            let context = this;
            context.btnTextGuardarCambios = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardando cambios...`;
            context.btnEnviarDisabled = true;
            let rutas = [];
            context.selectedRoutes.forEach((e) => {
                rutas.push(e);
            });

            var data = { rutas: rutas, wpCurso: context.course };

            console.log(data);
            axios
                .post("/dashboard/routes/save-course-routes", data)
                .then((res) => {
                    context.selectedRoutes = [];
                    context.reloadTable();
                    context.close();
                })
                .catch((err) => {
                    console.log(err);
                    context.btnEnviarDisabled = false;
                    context.btnTextGuardarCambios = "Guardar cambios";
                });
        },
        disableButton(isTrue) {
            if(isTrue){
                document.getElementById("update-button-route").setAttribute("disabled", "");
            }else{
                document.getElementById("update-button-route").removeAttribute("disabled");
            }
        },
        selectAll(){
            let context = this;
            context.selectedRoutes = [];
            let ids = document.getElementsByClassName("inputUser");
            for(let i=0;i<ids.length;i++){
                if((context.isCheckedSelectAll && ids[i].disabled == false) || (ids[i].disabled && ids[i].checked)){
                    context.selectedRoutes.push(ids[i].value);
                }
            }
            if(context.isCheckedSelectAll) context.btnEnviarDisabled = false;
        },
    },
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}

.modal-dialog-scrollable .modal-body {
    max-height: 78vh;
}
</style>
